import Rx from 'rxjs/Rx';
import { cloneDeep } from 'lodash';
import { exportToCSV } from '../../shared/utils/export.utils';
import AcrewardsModel from './model/acrewards.model';
import moment from 'moment';

class AcrewardsController {
    constructor(AcrewardsStore, PageService, $timeout, $scope, $translate) {
        'ngInject';

        this.AcrewardsStore = AcrewardsStore;
        this.PageService = PageService;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.$translate = $translate;
    }

    $onInit() {
        this.model = new AcrewardsModel();
        this.subject = new Rx.BehaviorSubject();
        this.sort = 'asc';

        $('.table-loading').show();
        $('.turnover-table').hide();

        this.AcrewardsStore.getProfile().then((resp) => {
          this.allowRevenueShare = resp.allow_revenue_share;
          this.getTurnOverCommissionDetails();
          this.updateModel();
        });
    }

    tableEventHandler() {
      this.$timeout(() => {
        $( window ).resize(function() {
          $('#rev-share-table').footable();
          $('#rev-share-table').trigger('footable_redraw');
          $('#turnover-table-product').footable();
          $('#turnover-table-product').trigger('footable_redraw');
        });
        $(window).trigger('resize');

        window.dispatchEvent(new Event('resize'));

        var evt = window.document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);
      }, 0);
    }

    renderTable(data) {
        $('.table-loading').hide();
        this.model.products = data.products;
        this.model.members = data.members;
        this.model.totals = data.totals;
        this.model.turnoverWinLossCommission = data.records;
        this.model.periods = data.period;
        this.model.pageParams = data.pageParams;
        this.model.allowRevenueShare = this.allowRevenueShare;
        this.model.sort = this.sort;
        this.$timeout(() => {
            $('.turnover-table').fadeIn(300);
        }, 300);
        this.tableEventHandler();
    }

    updateModel() {
        this.AcrewardsStore.getDashboardDetails().then((details) => {
            this.model.currency = details.others.currency;
            this.model.verifiedAt = details.others.verifiedAt;
            this.model.status = details.others.verifiedAt ? this.$translate.instant('Verified') : this.$translate.instant('Not Verified');
        });
    }

    getTurnOverCommissionDetails() {
        let payload = {
            hideZeroCommission: 1,
            limit: 10,
            page: 1,
            precision: 2,
            orderBy: 'productName',
        };

        this.AcrewardsStore.getTurnOverCommissionList(payload).then((resp) => {
            this.renderTable(resp);
        });
    }

    exportToCSV() {
        $('.export-csv').html('Generating...');
        let orderBy = this.model.filterRevenueShare ? 'memberId' : 'productName';
        let payload = {
            dwlDateFrom: this.model.periods.dwlDateFrom,
            dwlDateTo: this.model.periods.dwlDateTo,
            filterRevenueShare: this.model.filterRevenueShare,
            limit: this.model.pageParams.recordsFiltered,
            hideZeroCommission: 1,
            orderBy: orderBy,
            page: 1,
            precision: 2,
            sort: "asc",
        }

        this.AcrewardsStore.filterAction(payload).then((resp) => {
            let firstColumnText = this.model.filterRevenueShare ? 'Member ID,Product' : 'Product,Member ID';
            let csvFileName = this.model.filterRevenueShare ? 'valid-turnovers-revenueshare.csv' : 'valid-turnovers-commission.csv';
            let csvContent = this.model.filterRevenueShare ? firstColumnText + ',W/L,Bonus,Revenue Share,\n' : firstColumnText + ',Total TO,Affiliate Commission,\n';
            let list = cloneDeep(resp.records);
            let resultTotalTurnover = '';
            let resultTotalCommission = '';
            let resultTotalRevenueShare = '';
            let resultTotalAffiliateBonus = '';
            let resultTotalWinLoss = '';
            let defaultCurrency = this.model.currency;

            for (let key in list) {
                let row = list[key];
                let productName = row.productName;
                let currencyCode = row.currencyCode;
                let totalTurnover = row.totalTurnover.rounded;
                let currencyCodeDefault = defaultCurrency;
                let totalCommission = row.totalAffiliateCommission.rounded;
                let totalBonus = row.totalBonus.rounded;
                let totalWinLoss = row.totalWinLoss.rounded;
                let totalRevenueShare = row.totalRevenueShare.rounded;

                if (!row.productName || row.productName == '') {
                    productName = 'No Product';
                    currencyCode = '';
                    totalTurnover = '';
                    currencyCodeDefault = '';
                    totalCommission = '';
                }

                csvContent += this.model.filterRevenueShare ? `${row.memberId},${productName}` : `${productName},${row.memberId}`;
                csvContent += this.model.filterRevenueShare ? `,${currencyCode} ${totalWinLoss}, ${currencyCode} ${totalBonus}, ${currencyCodeDefault} ${totalRevenueShare},\n` : `,${currencyCode} ${totalTurnover},${currencyCodeDefault} ${totalCommission},\n`;
            }

            angular.forEach(resp.totals, (val, key) => {
                resultTotalTurnover += val.currencyCode +' '+ val.totalTurnover.rounded + ' ';
                resultTotalAffiliateBonus += val.currencyCode +' '+ val.totalAffiliateBonus.rounded + ' ';
                resultTotalWinLoss += val.currencyCode +' '+ val.totalWinLoss.rounded + ' ';
            });

            angular.forEach(resp.totals, (val, key) => {
                if (defaultCurrency == val.currencyCode) {
                    resultTotalCommission += val.currencyCode +' '+ val.totalAffiliateCommission.rounded + ' ';
                    resultTotalRevenueShare += val.currencyCode +' '+ val.totalAffiliateRevenueShare.rounded + ' ';
                }
            });

            if (resp.period.dwlDateFrom) {
              resp.period.dwlDateFrom = moment(resp.period.dwlDateFrom).format('YYYY-MM-DD');
            }

            if (resp.period.dwlDateTo) {
              resp.period.dwlDateTo = moment(resp.period.dwlDateTo).format('YYYY-MM-DD');
            }

            csvContent += this.model.filterRevenueShare ? 'Date Covered,,Total WinLoss, Total Bonus, Total Affiliate Revenue Share,\n' : 'Date Covered,,Total Turnover,Total Affiliate Commission,\n';
            csvContent += this.model.filterRevenueShare ? `${resp.period.dwlDateFrom} - ${resp.period.dwlDateTo},,${resultTotalWinLoss},${resultTotalAffiliateBonus},${resultTotalRevenueShare},\n`: `${resp.period.dwlDateFrom} - ${resp.period.dwlDateTo},,${resultTotalTurnover},${resultTotalCommission},\n`;
            exportToCSV(csvContent, csvFileName);
            $('.export-csv').html('Export as CSV');
        });
    }

    onFiltered(data, total) {
        this.model.turnoverWinLossCommission = data;
        this.model.totals = total;
        this.$scope.$broadcast ('resetPages');
        this.renderTable(data);
    }

    onOrderBy(order, periods, filterRevenueShare, sort = '') {
        this.model.filterRevenueShare = filterRevenueShare;
        this.sort = sort == 'asc' ? 'desc' : 'asc';
        this.model.orderBy = order;

        let payload = {
            limit: 10,
            page: 1,
            precision: 2,
            orderBy: order,
            dwlDateFrom: periods.dwlDateFrom,
            dwlDateTo: periods.dwlDateTo,
            filterRevenueShare: this.model.filterRevenueShare,
            sort: this.sort,
            hideZeroCommission: 1,
        };

        $('.table-loading').show();
        $('.turnover-table').hide();
        $('.turnover-table').unbind();

        this.AcrewardsStore.filterAction(payload).then((resp) => {
            $('.turnover-table').unbind();
            this.$scope.$broadcast ('resetPages');
            this.sort = sort == 'asc' ? 'desc' : 'asc';
            this.renderTable(resp);
        });
    }

    onPageClicked(page, offset, orderBy, periods, filterRevenueShare, sort) {
        this.onPaginate(page, offset, orderBy, periods, filterRevenueShare, sort);
    }

    onPaginate(page, offset, orderBy, periods, filterRevenueShare, sort) {
        this.model.pageParams.page = page;
        this.model.pageParams.offset = offset;
        this.model.pageParams.orderBy = orderBy;
        this.model.pageParams.precision = 2;
        this.model.dateFrom = periods.dwlDateFrom;
        this.model.dateTo = periods.dwlDateTo;
        this.model.filterRevenueShare = filterRevenueShare;
        this.model.pageParams.sort = sort;
        this.model.pageParams.hideZeroCommission = 1;
        this.AcrewardsStore.filterAction(this.model.toPayload()).then((resp) => {
            this.renderTable(resp);
        });
    }

    onCustomerProductsLoaded(customerProductsList) {
        this.model.availableBalance = customerProductsList.balance;
    }
}

export default AcrewardsController;


// WEBPACK FOOTER //
// ./client/app/pages/acrewards/acrewards.controller.js